(function () {
  function initialiseClinicalHome(root) {
    if (!root || root.dataset.pgxInitialised === 'true') return;
    root.dataset.pgxInitialised = 'true';

    var quiz = root.querySelector('[data-pgx-quiz]');
    if (!quiz) return;

    var answer = { age: null, size: null, goal: null };
    var currentStep = 0;
    var cards = quiz.querySelectorAll('[data-pgx-step]');
    var result = quiz.querySelector('[data-pgx-result]');
    var productData = JSON.parse(quiz.querySelector('[data-pgx-products]').textContent || '{}');

    function displayStep(index) {
      currentStep = index;
      cards.forEach(function (card, position) {
        card.classList.toggle('is-active', position === index);
      });
      if (result) result.classList.remove('is-active');
    }

    function updateNext(step) {
      var next = quiz.querySelector('[data-pgx-next="' + step + '"]');
      if (!next) return;
      var field = step === 0 ? 'age' : step === 1 ? 'size' : 'goal';
      next.disabled = !answer[field];
    }

    quiz.querySelectorAll('[data-pgx-choice]').forEach(function (choice) {
      choice.addEventListener('click', function () {
        var field = choice.dataset.pgxField;
        var value = choice.dataset.pgxValue;
        answer[field] = value;
        choice.closest('[data-pgx-step]').querySelectorAll('[data-pgx-choice]').forEach(function (sibling) {
          sibling.classList.remove('is-selected');
          sibling.setAttribute('aria-pressed', 'false');
        });
        choice.classList.add('is-selected');
        choice.setAttribute('aria-pressed', 'true');
        updateNext(Number(choice.dataset.pgxStep));
      });
    });

    quiz.querySelectorAll('[data-pgx-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = Number(button.dataset.pgxNext);
        if (step < 2) {
          displayStep(step + 1);
        } else {
          showResult();
        }
      });
    });

    quiz.querySelectorAll('[data-pgx-back]').forEach(function (button) {
      button.addEventListener('click', function () {
        displayStep(Math.max(0, Number(button.dataset.pgxBack) - 1));
      });
    });

    function showResult() {
      var product = productData[answer.goal] || productData.general;
      if (!product || !result) return;
      cards.forEach(function (card) { card.classList.remove('is-active'); });
      result.classList.add('is-active');
      result.querySelector('[data-pgx-result-image]').src = product.image;
      result.querySelector('[data-pgx-result-image]').alt = product.title;
      result.querySelector('[data-pgx-result-range]').textContent = product.range;
      result.querySelector('[data-pgx-result-name]').textContent = product.title;
      result.querySelector('[data-pgx-result-copy]').textContent = product.copy;
      result.querySelector('[data-pgx-result-link]').href = product.url;
      result.querySelector('[data-pgx-result-link]').textContent = 'View ' + product.title;
    }

    var restart = quiz.querySelector('[data-pgx-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        answer = { age: null, size: null, goal: null };
        quiz.querySelectorAll('[data-pgx-choice]').forEach(function (choice) {
          choice.classList.remove('is-selected');
          choice.setAttribute('aria-pressed', 'false');
        });
        quiz.querySelectorAll('[data-pgx-next]').forEach(function (button) { button.disabled = true; });
        displayStep(0);
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-pgx-home]').forEach(initialiseClinicalHome);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (event) {
    initialiseClinicalHome(event.target.querySelector('[data-pgx-home]'));
  });
})();
